import React, { Component } from "react";
import {
  Divider,
  Row,
  Layout,
  Popover,
  Icon,
  AutoComplete,
  Tag,
  Button,
} from "antd";
import AllStagesTableByEnemies from "../table/AllStagesTableByEnemies";
import axios from "axios";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import ReactGA from "react-ga4";
// import HorizontalAdPopup from "../ads/HorizontalAdPopup";
import version from "./version";

const { Sider, Content } = Layout;
const { CheckableTag } = Tag;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  
};

// const EnemyList = {
//   sampledata: [
//     {
//       enemy_no: "000",
//       enemy_name_en: "Doge",
//       type: "White ",
//     },
//     {
//       enemy_no: "001",
//       enemy_name_en: "Snache",
//       type: "White ",
//     },
//     {
//       enemy_no: "002",
//       enemy_name_en: "Those Guys",
//       type: "White ",
//     },
//   ],
// };

// const sampleEnemyList = ["Doge", "Snache", "Hippoe", "THE SLOTH"];

class AllEnemies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStages: [],
      viewportHeight: 0,
      dataSource: [],
      someVal: "",
      allEnemiesName: [],
      selectedEnemies: [],
      checkedEnemies: [],
    };

    // this.hydrateStateWithLocalStorage = this.hydrateStateWithLocalStorage.bind(
    //   this
    // );
  }

  // hydrateStateWithLocalStorage() {
  //   // for all items in state
  //   for (let key in this.state) {
  //     // if the key exists in localStorage
  //     if (localStorage.hasOwnProperty(key)) {
  //       // get the key's value from localStorage
  //       let value = localStorage.getItem(key);
  //       try {
  //         value = JSON.parse(value);
  //         // this.setState({ [key]: value });
  //         this.setState({ [key]: value }, function () {});
  //       } catch (e) {
  //         // handle empty string
  //         this.setState({ [key]: value });
  //       }
  //     }
  //   }
  // }

  componentDidMount() {
    // this.hydrateStateWithLocalStorage();
    // window.addEventListener(
    //   "beforeunload",
    //   this.saveStateToLocalStorage.bind(this)
    // );

    document.title = "All Stages by Enemies | Battle Cats Wiki for Cat Stats";

    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    axios
      .get("https://onestoppress.com/api/allstagesbyenemies")
      .then((res) => {
        let StageList = res.data.sampledata;

        this.setState({ dataSource: StageList }, function () {
          // console.log("state: ", this.state.dataSource);
        });
        this.setState({ selectedStages: StageList });
      })
      .catch((err) => console.log("err: ", err));

    axios
      .get("https://onestoppress.com/api/allenemiesname")
      .then((res) => {
        let allEnemiesName = res.data.sampledata[0].enemy_name_en;
        this.setState({ allEnemiesName: allEnemiesName }, function () {
          // console.log("state: ", this.state.allEnemiesName);
        });
      })
      .catch((err) => console.log("err: ", err));
    // this.setState({ allEnemiesName: sampleEnemyList });
  }

  // saveStateToLocalStorage() {
  //   // for every item in React state
  //   for (let key in this.state) {
  //     // save to localStorage
  //     localStorage.setItem(key, JSON.stringify(this.state[key]));
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
    // window.removeEventListener(
    //   "beforeunload",
    //   this.saveStateToLocalStorage.bind(this)
    // );

    // // saves if component has a chance to unmount
    // this.saveStateToLocalStorage();
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 768) {
      adjustViewport = 135;
    } else {
      adjustViewport = 290;
    }

    this.setState({
      viewportHeight: window.innerHeight - adjustViewport,
    });
  }, this.props.applyViewportChange);

  onChange = (value) => {
    this.setState({ someVal: value });
  };

  onSelect = (value) => {
    this.setState({ someVal: "" });
    // console.log("value: " + value);
    const enemyAlreadySelected = this.state.selectedEnemies.some((el) => {
      return el === value;
    });

    if (!enemyAlreadySelected) {
      this.setState(
        (prevState) => ({
          selectedEnemies: [...prevState.selectedEnemies, value],
          checkedEnemies: [...prevState.checkedEnemies, value],
        }),
        function () {
          // console.log("onSelect selectedEnemies: ", this.state.selectedEnemies);
          // console.log("onSelect checkedEnemies: ", this.state.checkedEnemies);
          let dataSource = this.state.dataSource;
          if (typeof value !== "undefined") {
            // console.log("value: " + value);
            let selectedStages = dataSource.filter((stage) =>
              this.state.checkedEnemies.every((enemy) =>
                stage.enemies_distinct.includes(enemy)
              )
            );
            this.setState({ selectedStages: selectedStages });
          }
        }
      );
    }
  };

  handleChange(tag, checked) {
    const { checkedEnemies } = this.state;
    const nextCheckedEnemies = checked
      ? [...checkedEnemies, tag]
      : checkedEnemies.filter((t) => t !== tag);
    this.setState({ checkedEnemies: nextCheckedEnemies });

    let dataSource = this.state.dataSource;
    if (typeof tag !== "undefined") {
      let selectedStages = dataSource.filter((stage) =>
        nextCheckedEnemies.every((enemy) =>
          stage.enemies_distinct.includes(enemy)
        )
      );
      this.setState({ selectedStages: selectedStages });
    }
  }

  handleClose = (removedTag) => {
    const selectedEnemies = this.state.selectedEnemies.filter(
      (tag) => tag !== removedTag
    );
    const { checkedEnemies } = this.state;
    const nextCheckedEnemies = checkedEnemies.includes(removedTag)
      ? checkedEnemies.filter((t) => t !== removedTag)
      : [...checkedEnemies];

    this.setState({
      selectedEnemies: selectedEnemies,
      checkedEnemies: nextCheckedEnemies,
    });

    let dataSource = this.state.dataSource;
    if (typeof removedTag !== "undefined") {
      // console.log("onHandleChange checkedEnemies: " + this.state.checkedEnemies);
      let selectedStages = dataSource.filter((stage) =>
        nextCheckedEnemies.every((enemy) =>
          stage.enemies_distinct.includes(enemy)
        )
      );
      this.setState({ selectedStages: selectedStages });
    }
  };

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              float: "left",
            }}
          >
            All Stages
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={<div>Updated to BattleCats Version {version}. </div>}
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout>
          <Sider
            width={220}
            className="sider filter"
            style={{
              padding: "0 12px 0 12px",
              background: "white",
              display: "none",
            }}
          ></Sider>
          <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
            <Content className="flexible-width">
              <Row style={{ padding: "16px 0 16px 0" }}>
                <AutoComplete
                  dataSource={this.state.allEnemiesName}
                  value={this.state.someVal || ""}
                  backfill={true}
                  onSelect={this.onSelect}
                  onChange={this.onChange}
                  style={{
                    opacity: "1",
                    float: "right",
                    display: "block",
                    maxWidth: "350px",
                    width: "100%",
                  }}
                  allowClear
                  placeholder="Search stage by enemies"
                  filterOption={(inputValue, option) =>
                    option.props.children
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                ></AutoComplete>
                {this.state.selectedEnemies.map((tag) => (
                  <div>
                    <CheckableTag
                      key={tag}
                      checked={this.state.checkedEnemies.indexOf(tag) > -1}
                      onChange={(checked) => this.handleChange(tag, checked)}
                      style={{ marginTop: "6px" }}
                    >
                      {tag}
                    </CheckableTag>
                    <Button
                      size="small"
                      ghost
                      style={{
                        marginLeft: "-8px",
                        fontSize: "16px",
                      }}
                      type="link"
                      shape="circle"
                      onClick={() => this.handleClose(tag)}
                    >
                      <Icon
                        type="close-circle"
                        theme="filled"
                        style={{ color: "#FFAA3B" }}
                      />
                    </Button>
                  </div>
                ))}
              </Row>
              <Row style={{ padding: "0px 0 0px 0" }}>
                <AllStagesTableByEnemies
                  selectedStages={this.state.selectedStages}
                  viewportHeight={this.state.viewportHeight}
                />
              </Row>
              <Row style={{ height: "50px" }}> </Row>
            </Content>
          </Layout>
        </Layout>
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default AllEnemies;

AllEnemies.propTypes = {
  applyViewportChange: PropTypes.number,
};

AllEnemies.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/AllStagesByEnemies.js